/**
 * Created by 槟 on 2018/4/10.
 */
export const UPDATE_SEARCH_RENT_DATA = 'editSearchRentData/UPDATE_SEARCH_RENT_DATA';
const initialState = {
  editSearchRentData: {
    nullArr: [],
    nullArr2: [],
    district_id: '',       //小区
    rental_mode: 1,        //合租
    min_price: '',         //最低价
    max_price: '',         //最高价
    bldroom_count: '',     //室
    hall_count: '',        //厅
    min_area: '',          //最小面积
    max_area: '',          //最大面积
    decoration_level: '',  //装修标准
    check_in_date: '',     //入住日期
    check_in_amount: '',   //入住人数
    overDate: false,
  },
};
const editSearchRentDataReducer = (editSearchRentData = 0, action)=> {
  switch (action.type) {
    case UPDATE_SEARCH_RENT_DATA:
      return {
        ...editSearchRentData,
        [action.subType]: action.data
      }
    default:
      return editSearchRentData
  }
}
export default (state = initialState, action) => {
  return {
    editSearchRentData: editSearchRentDataReducer(state.editSearchRentData, action)
  };
}
export const dispatch_func = {
  update_editSearchRentData: (data, type) => {
    return dispatch => {
      dispatch({
        type: UPDATE_SEARCH_RENT_DATA,
        data: data,
        subType: type
      });
    }
  },
};


// WEBPACK FOOTER //
// ./src/modules/editSearchRent.js